<div class="price-list-data" *ngFor="let priceList of priceLists">
  <div class="price-list-data__header">
    <lx-price-lists-portal-school-header
      [school]="priceList.name"
      [country]="priceList.country"
      [isPlus30]="priceList.isPlus30"
      [company]="company"
      [applicationForms]="applicationForms"
    >
    </lx-price-lists-portal-school-header>
  </div>
  <lx-price-lists-portal-adults-course-table
    [courses]="priceList.courses"
    [courseNotes]="priceList.courseNotes"
    [courseStartDates]="priceList.courseStartDates"
    [currency]="priceList.currency"
    [company]="priceList.company"
  ></lx-price-lists-portal-adults-course-table>
  <div class="price-list-data__two-columns-container table-section">
    <div class="price-list-data__first-column">
      <lx-price-lists-portal-pathway-program-table
        *ngIf="priceList.pathwayPrograms && priceList.pathwayPrograms.length > 0"
        [pathwayPrograms]="priceList.pathwayPrograms"
        [currency]="priceList.currency"
        [company]="priceList.company"
      ></lx-price-lists-portal-pathway-program-table>
      <lx-price-lists-portal-pathway-program-fee-table
        *ngIf="priceList.pathwayFees && priceList.pathwayFees.length > 0"
        [pathwayProgramFees]="priceList.pathwayFees"
        [currency]="priceList.currency"
        [company]="priceList.company"
      ></lx-price-lists-portal-pathway-program-fee-table>
    </div>
    <div class="price-list-data__second-column">
      <lx-price-lists-portal-exam-preparation
        *ngIf="priceList.examPreparations"
        [company]="priceList.company"
        [examPreparation]="priceList.examPreparations"
        [currency]="priceList.currency"
      ></lx-price-lists-portal-exam-preparation>
    </div>
  </div>
  <lx-price-lists-portal-student-preparation-table
    *ngIf="priceList.studentPreparations && priceList.studentPreparations.length > 0"
    [studentPreparations]="priceList.studentPreparations"
    [currency]="priceList.currency"
    [company]="priceList.company"
  ></lx-price-lists-portal-student-preparation-table>
  <lx-price-lists-portal-accommodation-table
    [accommodations]="priceList.accommodations"
    [currency]="priceList.currency"
    [company]="priceList.company"
  ></lx-price-lists-portal-accommodation-table>
  <div class="price-list-data__two-columns-container table-section">
    <div class="price-list-data__first-column">
      <lx-price-lists-portal-transfer-table
        [company]="priceList.company"
        [transfers]="priceList.transfers"
        [currency]="priceList.currency"
      ></lx-price-lists-portal-transfer-table>
      <lx-price-lists-portal-general-fee-table
        [company]="priceList.company"
        [currency]="priceList.currency"
        [generalFees]="priceList.generals"
      ></lx-price-lists-portal-general-fee-table>
    </div>
    <div class="price-list-data__second-column">
      <lx-price-lists-portal-more-info [company]="priceList.company" [priceList]="priceList" [currency]="priceList.currency"></lx-price-lists-portal-more-info>
    </div>
  </div>
  <lx-additional-info *ngIf="priceList?.additionalInfo?.length > 0" [additionalInformation]="priceList?.additionalInfo"></lx-additional-info>
</div>
